import { render, staticRenderFns } from "./PopulationCard.vue?vue&type=template&id=3fb2da0b&scoped=true"
import script from "./PopulationCard.vue?vue&type=script&lang=js"
export * from "./PopulationCard.vue?vue&type=script&lang=js"
import style0 from "./PopulationCard.vue?vue&type=style&index=0&id=3fb2da0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2da0b",
  null
  
)

export default component.exports